// extracted by mini-css-extract-plugin
export var container = "modal-module--container--0eb7f";
export var iconContainer = "modal-module--icon-container--40425";
export var overlayContainer = "modal-module--overlay-container--b5cae";
export var titleContainer = "modal-module--title-container--4c3c3";